export default __webpack_public_path__ + "static/media/background.92f9654e.jpg";